export default {
  errorFetching: false,
  loading: false,
  campaigns: null,
  selectedCampaign: null,
  selectedCategory: null,
  altitude: null,
  head: 0,
  headFrom: '',
  latLng: null,
  name: '',
  date: '',
  pan: null,
  pitch: null,
  roll: null,
  laterals: null,
  neighbours: null,
  selectedLateral: null,
  folderPanoramaCampaign: null,
  folderLateralsCampaign: null,
  folderPointCloudCampaign: null,
  folderPanorama: null,
  folderPointCloud: null,
  screenshot: null,
  srcPannellum: null,
  srcLateral: null,
  srcPotree: null,
  showPannellum: true,
  showLateral: false,
  showPotree: true,
  result: null
}
